module.exports = __webpack_public_path__ + "img/project10_11.jpg.e95ace5c.webp";